import { render, staticRenderFns } from "./SuperAdminCourseApplication.vue?vue&type=template&id=172bd038&scoped=true"
import script from "./SuperAdminCourseApplication.vue?vue&type=script&lang=js"
export * from "./SuperAdminCourseApplication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172bd038",
  null
  
)

export default component.exports